import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useSponsor } from '../contexts/SponsorContext';
import LivePriceRight from './LivePriceRight';
import LivePriceBig from './LivePriceBig';
import OrderBook from './OrderBook';
import MarketDepth from './MarketDepth';
import SponsoredTrade from './SponsoredTrade';
import TechnicalSentiments from './TechnicalSentiments';
import { X } from 'lucide-react';

interface RightPanelProps {
  symbol: string;
  isVisible: boolean;
  onClose: () => void;
  selectedSymbol: string;
  currentPrice: string;
  priceChange: string;
  isPricePositive: boolean;
  priceColor: string;
  isRightPanelVisible?: boolean;
}

const RightPanel: React.FC<RightPanelProps> = ({ 
  symbol, 
  isVisible, 
  onClose,
  selectedSymbol,
  currentPrice,
  priceChange,
  isPricePositive,
  priceColor,
  isRightPanelVisible = false,
}) => {
  const { theme } = useTheme();
  const { isSponsorEnabled } = useSponsor();
  const [isOrderBookHovered, setIsOrderBookHovered] = useState(false);

  
  return (
         <div
       className={`w-64 min-w-64 max-w-64 ${theme === 'light' ? 'theme-bg-secondary' : ''} border-l theme-border px-2 me-0  pb-[60px] overflow-y-auto scrollbar-hide space-y-0 relative`}
       style={{ height: 'calc(100vh - 00px)', zIndex: '21' }}
     >
      {/* Order Book Component */}
      <div 
        className="mt-1 relative"
        onMouseEnter={() => setIsOrderBookHovered(true)}
        onMouseLeave={() => setIsOrderBookHovered(false)}
      >
        {/* Close Button - Only visible on hover */}
        {(
          <div className="flex items-center justify-end mb-0 absolute top-1 right-2 z-30" style={{ top: '7px' }}>
            <button
              onClick={onClose}
              className="p-1 rounded-sm transition-all duration-200"
              title="Close panel"
            >
              <X className="h-3 w-3 theme-text-quaternary group-hover:text-white transition-colors duration-200" />
            </button>
          </div>
        )}
        
        <OrderBook 
          selectedSymbol={selectedSymbol}
          currentPrice={currentPrice}
          priceChange={priceChange}
          isPricePositive={isPricePositive}
          priceColor={priceColor}
        />
      </div>

      {/* Market Depth Component */}
      <MarketDepth selectedSymbol={selectedSymbol} />
      
      {/* Conditional rendering based on sponsor toggle */}
      {isSponsorEnabled ? (
        <SponsoredTrade isRightPanelVisible={isRightPanelVisible} />
      ) : (
        <>
          <LivePriceBig 
            selectedSymbol={selectedSymbol}
            currentPrice={currentPrice}
            priceChange={priceChange}
            isPricePositive={isPricePositive}
            priceColor={priceColor}
            isRightPanelVisible={isRightPanelVisible}
          />
          {/* Technical Sentiments - positioned right below LivePriceBig */}
          <TechnicalSentiments isRightPanelVisible={isRightPanelVisible} />
        </>
      )}
    </div>
  );
};

export default RightPanel;


